<div class="LCS_confirmation text-center">
    <h4>{{data.message}}</h4>
   
    <div class="assessment_mt-25 text-center">
        <button class="btn btn-outline-secondary mr-4" type="button" (click)="takeAction('cancel')">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="takeAction('delete')">Delete</button>
    </div>
</div>
